import { ReactNode } from 'react';
import styles from './SplitView.module.css';

const SplitView = ({ children }: { children: ReactNode }) => {
  return <div className={styles.splitView}>{children}</div>;
};

const Sidebar = ({ children }: { children: ReactNode }) => {
  return <div className={styles.sidebar}>{children}</div>;
};

const Item = ({ children, isSelected }: { children: ReactNode; isSelected: boolean }) => (
  <div className={`${styles.item} ${isSelected ? styles.itemSelected : ''}`}>{children}</div>
);

const Content = ({ children }: { children: ReactNode }) => (
  <div className={styles.content}>{children}</div>
);

SplitView.Sidebar = Sidebar;
SplitView.Content = Content;
SplitView.Item = Item;

export default SplitView;
